// extracted by mini-css-extract-plugin
module.exports = {"paper":"Paper_paper__1TrbE","paper_color_primary":"Paper_paper_color_primary__2KfT0"};